import '../styles/index.scss';

$(document).ready(() => {
    var urlParams = new URLSearchParams(window.location.search);
    var accountGuid = urlParams.get('a');
    var activityGuid = urlParams.get('p');
    var server = urlParams.get('g');

    var url = `https://${server}.embercrm.com/api/PatronAppointment/${accountGuid}/${activityGuid}`;
    //var url = `http://localhost:59634/api/PatronAppointment/${accountGuid}/${activityGuid}`;

    function getData() {
        $.getJSON(url, (data) => {
            var startDate = new Date(data.dateStart + 'Z');

            $('#date').text(startDate.toLocaleString('en-US'));
            $('#services').text(data.services);
            $('#status').text(data.status);
            $('#addToGoogle').attr('href', `https://www.google.com/calendar/render?action=TEMPLATE&text=${data.services} with ${data.scheduledWith}&dates=${data.dateStart.split('-').join('').split(':').join('') + 'Z'}/${data.dateEnd.split('-').join('').split(':').join('') + 'Z'}&location=${data.locationAddress}&details=https://isch.co/${data.shortUrlCode}&sf=true&output=xml`);
            $('#downloadIcs').attr('href', `${url}/ical`);

            if (data.scheduledWith) {
                $('#scheduledWith').text(data.scheduledWith);
            } else {
                $('#scheduledWith').parent().remove();
            }

            if (data.locationName) {
                $('#location').text(data.locationName + ', ' + data.locationAddress);
                $('#map').attr('href', 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(data.locationAddress));
            } else {
                $('#location').parent().remove();
            }

            if (data.locationPhone) {
                $('#locationPhone').text(data.locationPhone);
            } else {
                $('#locationPhone').parent().remove();
            }

            if (data.locationInstructions) {
                $('#locationInstructions').text(data.locationInstructions);
            } else {
                $('#locationInstructions').parent().remove();
            }

            if (data.dateCancelled) {
                var canceledDate = new Date(data.dateCancelled + 'Z');

                $('#confirmedDateContainer').addClass('d-none');
                $('#cancelledDateContainer').removeClass('d-none');
                $('#cancelledDate').text(canceledDate.toLocaleString('en-US'));
                $('#buttonContainer').hide();
                $('#canceledMessage').show();
            }
    
            if (data.dateConfirmed) {
                var confirmedDate = new Date(data.dateConfirmed + 'Z');

                $('#confirmedDateContainer').removeClass('d-none');
                $('#confirmedDate').text(confirmedDate.toLocaleString('en-US'));
                $('#confirmButton').hide();
            }

            var visible = dateDiffInDays(new Date(), startDate) <= 3;
            if (!visible) {
                $('#status').parent().remove();
                $('#confirmButton').remove();
            }
        })
        .fail(() => showError())
        .always(() => { $('body').addClass('visible'); });
    }

    function showError() {
        $('#contentContainer').hide();
        $('#buttonContainer').hide();
        $('#apiErrorMessage').removeClass('d-none');
    }

    function dateDiffInDays(a, b) {
        const _MS_PER_DAY = 1000 * 60 * 60 * 24;
        const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
      
        return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    }

    window.patchAppointment = (action) => {
        $.ajax({
            type: 'PATCH',
            url: url,
            data: JSON.stringify({ action: action }),
            contentType: 'application/json'
        })
        .done(() => getData())
        .fail(() => showError());
    };

    window.downloadAppointment = (action) => {
        fetch(url + '/ical')
        .then(resp => resp.blob())
        .then(blob => {
            var reader = new FileReader();
            reader.onload = (e) => {
               var bdata = btoa(reader.result);
               var datauri = 'data:' + isbContentType + ';base64,' + bdata;
               var newWindow = window.open(datauri);
               newWindow = setTimeout(() => { newWindow.document.title = isbFilename; }, 10);
            };
            reader.readAsBinaryString(blob);

            // const url = window.URL.createObjectURL(blob);
            // const a = document.createElement('a');
            // a.href = url;
            // a.download = 'appointment.ics';
            // document.body.appendChild(a);
            // a.click();
            // window.URL.revokeObjectURL(url);
        })
        .catch(() => alert('Could not download appointment'));
    };

    getData();
});